<template>
  <v-flex xs12 sm10 md8 lg6>
    <v-card class="pa-4">
      <v-flex xs12 pb-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-layout row wrap justify-space-between align-center>
          <v-flex xs12>
            <v-autocomplete
              v-if="!isLocalAdmin"
              :items="companies"
              :label="$lang.actions.selectCompany"
              v-model="printServer.companyId"
              item-text="name"
              item-value="id"
              required
              :readonly="isEdit"
              :loading="companyLoading"
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$lang.labels.printServerName"
              v-model="printServer.name"
              required
              :rules="[v => !!v || `${$lang.errors.missingPrintServerName}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              chips
              deletable-chips
              multiple
              :items="mappedPrinters"
              :label="$lang.actions.selectPrinters"
              v-model="printServer.printers"
              required
              :disabled="mappedPrinters.length === 0"
              :loading="printersLoading"
              :rules="[() => printServer.printers.length > 0 || `${$lang.errors.missingPrinters}`]"
            />
          </v-flex>
          <v-flex xs12 v-if="isEdit">
            <v-textarea
              id="key"
              :label="$lang.labels.key"
              v-model="printServer.printServerKey"
              auto-grow
              rows="1"
              :readonly="isEdit"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$lang.labels.records"
              v-model.number="printServer.fetchRecordsLimit"
              type="number"
              min="1"
              max="128"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="mt-3">
          <v-btn
            flat class="ml-0"
            @click="$router.push({ name: 'printServers' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <div>
            <v-btn class="primary" v-if="isEdit" @click="copyKey">
              {{$lang.actions.copyKey}}
            </v-btn>
            <v-btn
              class="primary mx-0"
              :disabled="!valid"
              @click="submit">
              {{ isEdit ? $lang.actions.update : $lang.actions.create}}
            </v-btn>
          </div>
        </v-layout>
      </v-form>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    data: () => ({
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      printersLoading: false,
      companies: [],
      printers: [],
      printServer: {
        companyId: null,
        name: null,
        printers:[],
        fetchRecordsLimit: 10,
      },
      isLocalAdmin: false,
    }),
    watch: {
      'printServer.companyId': function(val) {
        this.fetchPrinters(val);
      },
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      mappedPrinters() {
        return this.printers.map(printer => ({
          text: `${printer.name} (${printer.printerStatus})`,
          value: printer.id,
        }));
      },
    },
    methods: {
      init() {
        const roles = JSON.parse(this.$cookie.get('roles') || '[]');
        this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                if (this.isLocalAdmin && this.companies.length === 1) this.printServer.companyId = this.companies[0].id;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      copyKey() {
        try {
          var copyText = document.getElementById('key');
          copyText.select();
          const success = document.execCommand('copy');
        } catch (e) {
          console.log(e);
        }
      },
      fetchPrinters(id) {
        this.printersLoading = true;
        this.printers = [];
        this.$http.get(`printer/fetchallforcompany/${id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.printersLoading = false;
              this.printers = res.body.printers;
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      submit() {
        if (!this.printServer.fetchRecordsLimit || this.printServer.fetchRecordsLimit < 1 || this.printServer.fetchRecordsLimit > 128) {
          this.err = 'Records for printing must be between 1 and 128.';
          return;
        }
        let url = this.isEdit ? `printserver/update/${this.$route.params.id}` : 'printserver/create';
        this.$http.post(url, this.printServer)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = this.isEdit ? 'Print Server updated successfuly' : 'Print Server created successfuly';
              setTimeout(() => {
                if (this.isEdit) {
                  this.success = '';
                } else {
                  this.$router.push({ name: 'printServers' });
                }
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.init()
        .then(() => {
          if (this.$route.params.id) {
            this.isEdit = true;
            this.$http.get(`printserver/fetchbyid/${this.$route.params.id}`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  this.printServer = res.body.printServers;
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
            }
        })
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// PrintServerDetails.vue?168563ad